import { Stack } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useLogin } from '../context/Login/LoginContext';
import { getBackendUrl } from '../util/envFn';

const GoogleLoginButton = () => {
    const { enqueueSnackbar } = useSnackbar();
    const { login } = useLogin();

    const handleSuccess = async (response: any) => {
        try {
            const result = await axios.post(getBackendUrl('/auth/google'), {
                token: response.credential
            });
            const { user, token } = result.data;
            login(user, token);
            enqueueSnackbar('Login successful', { variant: 'success' });
        } catch (error) {
            console.error('Login failed:', error);
            enqueueSnackbar('Login failed. Please try again.', { variant: 'error' });
        }
    };

    const handleError = () => {
        enqueueSnackbar('Login failed. Please try again.', { variant: 'error' });
    };

    return (
        <Stack width={1} justifyContent="center" alignItems="center">
            <GoogleLogin
                onSuccess={handleSuccess}
                onError={handleError}
                theme="outline"
                size="large"
                useOneTap
            />
        </Stack>
    );
};

export default GoogleLoginButton; 